export default {
    title: 'Statistikmeldungen an StaLa übermitteln',

    transferWillTakeTime: 'Die Übermittlung der Statistikmeldungen an StaLa kann einige Zeit in Anspruch nehmen. Es wird im Hintergrund erledigt und du wirst benachrichtigt, sobald die Übermittlung abgeschlossen ist.',

    testingMode: 'Testmodus',
    testingModeHelpText: 'Im Testmodus werden die Statistikmeldungen zum Testen ans StaLa übermittelt. Die Daten werden dort nicht gespeichert, es wird nur auf mögliche Fehler geprüft.',

    statisticProcessesWithMissingOrganisationData: 'Die folgenden Statistikmeldungen können aufgrund fehlender statistischer Kennnummer der Organisation nicht übermittelt werden:',
    statisticProcessesWithMissingAssociationSettings: 'Die folgenden Statistikmeldungen können aufgrund fehlender eCore-Einstellungen des Verbands nicht übermittelt werden:',
    statisticProcessesFehlanzeige: 'Die folgenden Statistikmeldungen können nicht übermittelt werden, da es sich um Fehlanzeigen handelt:',
    statisticProcessesWithNotAllowedStatusTransition: 'Die folgenden Statistikmeldungen können nicht übermittelt werden, da der aktuelle Status keine Übermittlung erlaubt:',

    transfer: 'Übermitteln',
    transferStartedSuccessfully: 'Übermittlung gestartet. Du wirst benachrichtigt, sobald die Übermittlung abgeschlossen ist.',
    errorOnTransferring: 'Fehler bei der Übermittlung der Statistikmeldungen ans StaLa.',
}